import { adminApproveRejectReviewAPI } from "./views/reviewsTool/api/adminApproveRejectReview";

const CoustomUrls = {
  signIn: `${process.env.REACT_APP_VEZEETA_REVIEWS_URL}/portal/login`,
  getOffers:`http://voffers-2-prelive.drbridge.org/api/portal/GetOffers`,
  getReviews:`${process.env.REACT_APP_VEZEETA_REVIEWS_URL}/portal/GetReviewsByStatus`,
  ApproveRejectReview:`${process.env.REACT_APP_VEZEETA_REVIEWS_URL}/portal/AdminApproveRejectReview`
};
export default CoustomUrls;
